import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DxLoadPanelComponent} from 'devextreme-angular';
import {Route, RouteLoader} from 'shared';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-tractors-history-metrics',
  templateUrl: './tractors-history-metrics.component.html',
  styleUrls: ['./tractors-history-metrics.component.scss']
})
export class TractorsHistoryMetricsComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  loader: RouteLoader;
  private loaderSub: Subscription;
  route: Route;

  isLoading: boolean;

  constructor(public host: ElementRef) {
  }

  ngOnInit(): void {
    this.loaderSub = this.loader.loading$.subscribe(isLoading => {
      this.isLoading = isLoading;
      if (!isLoading) {
        this.route = this.loader.route;
      }
    });
  }

  ngAfterViewInit(): void {
    /*setTimeout(() => {
      this.isLoading = true;
    }, 3000);*/
  }

  ngOnDestroy(): void {
    this.loaderSub.unsubscribe();
  }

}
